import React from 'react'
import NurtureCardHeader from './childCompsForNurtureCard/NurtureCardHeader'
import "./sideCardForAutoNurtureStyles.css"
function GenerateNurtureCard({setOpenGenerateNurture,campaignID}) {
    
  return (
    <>
    <NurtureCardHeader setOpenGenerateNurture={setOpenGenerateNurture} campaignID={campaignID}/>
    </>
  )
}

export default GenerateNurtureCard